<template>
  <div>
    <el-button 
    v-bind:style="{ backgroundColor: rowdata.ifuploadfile ? '#93bbfa' : '#e6e8a0' }"
    @click="dialog = true">
      <i>&#128206;</i>
    </el-button>
    <el-dialog v-if="dialog" :visible.sync="dialog">
      <el-upload v-if="authorization" drag
        :on-change="handlechange" :on-remove="handlechange" :file-list="filelist" :auto-upload="false" :multiple="true"
        action>
        <i class="el-icon-upload"></i>
        <div style="color:red;" slot="tip">
          <el-button v-show="thedata.doc.length > 0" @click="dialogdelete = true">删除</el-button>

          <el-dialog append-to-body :visible.sync="dialogdelete">
            <!-- <p>{{"已上传附件:"+rowdata.att}}</p> -->
            <el-checkbox-group v-model="deletes">
              <el-checkbox v-for="(data, index) in thedata.doc" :label="index" :key="index">{{ data.Filename
              }}</el-checkbox>
            </el-checkbox-group>

            <el-button v-show="deletes.length > 0" type="danger" @click="filedelete">确认删除</el-button>
          </el-dialog>


          <el-button type="primary" style="width:50%" v-if="filelist.length > 0" @click="submit">上传</el-button>
        </div>
      </el-upload>
      <singleclct v-if="dataready" 
      :thedata="thedata" 
      tabletitle="" 
      collection="archive"
      :ifheaderoperate="false"
      :searchval="'^' + rowdata._id + '$'">
      </singleclct>
    </el-dialog>

    <!-- <el-input-number v-if="filelist.length>0" v-model="torow"></el-input-number> -->

  </div>
</template>

<script>

import singleclct from "@/components/news/singleclct.vue";
export default {
  components: { singleclct },
  props: ["rowdata"],
  mounted() {
  },
  data() {
    return {
      dataready: false,
      deletes: [],
      thedata: { doc: [] }, //{ archive: [] },
      dialogdelete: false,
      dialog: false,
      filelist: [],
      formdata: new FormData(),
      totalfilesize: 0
    };
  },

  computed: {
    collection() { return this.$store.state.collection.value },
    //判断文件上传的权限
    authorization(){
      return (
      this.rowdata.name ==this.$store.state.user || 
      this.$store.state.roles.includes('superadmin')||
      this.$store.state.roles.includes("dcadmin_"+this.$store.state.clct)
      )
    }
   
    // cat() {
    //   return this.$store.state.collections.filter(function(obj) {
    //     return !obj.value.includes("tempexcel");
    //   });
    // }
  },
  watch: {
    dialog(newval, oldval) {
      if (newval == false) {
        //隐藏时清空
        this.reset()

      }
      if (newval == true) {
        this.dataready = false
        this.$axios
          .post(url + "aggregateclct", {
            loadingstatus: "none",
            collections: ["archive"],
            model: "filter",//可以不设置，服务器默认为"generalsearch"，可设置为filter
            value: { base: "^" + this.rowdata._id + "$" },
            thefields: { _id: 1, path: 1, Filename: 1 },
          })
          .then((res) => {
            this.thedata = res.data["archive"]
            if (this.thedata.doc && this.thedata.doc.length > 0) {
              this.dataready = true
            }
          })
      }

    }
  },
  methods: {


    handlechange(file, filelist) {


      //上传文件大小限制
      if (!this.$store.state.roles.includes("superadmin")) {
        this.totalfilesize = this.totalfilesize + file.size
        if ((this.totalfilesize / 1024) > 200) {
          this.totalfilesize = this.totalfilesize - file.size
          this.$message("File size should not larger than 200KB")
          for (var i = 0; i < filelist.length; i++) {
            if (filelist[i].uid == file.uid) {
              filelist.splice(i, 1)
            }
          }
          return
        }

      }


      // console.log(filelist)
      this.formdata.set("id", this.rowdata._id)
      this.formdata.set("collection", this.collection)
      this.formdata.set("files", null)
      // this.formdata.append("id",this.rowdata._id)
      // this.formdata.append("collection",this.collection)
      this.filelist = filelist
      filelist.forEach((o, i) => {
        if (o.raw) {
          this.formdata.append("files", o.raw)
        }
      })
      // this.formdata.append("filelist",filelist)
      // this.formdata.append("filename",file.name)
      // this.formdata.append("file", file.raw);
      // fetch(file.url)
      //   .then(res => res.blob())
      //   .then(blob => {
      //     this.formdata.append("excel", blob);
      //   });
    },

    reset() {
      this.dialogdelete = false;
      this.dataready = false;
      this.deletes = [];
      this.dialog = false;
      this.filelist = [];
      this.formdata = new FormData();
      this.totalfilesize = 0
    },

    submit() {
      // this.formdata.append("id",this.rowdata._id)
      // this.formdata.append("collection",this.collection)
      this.$axios({
        method: "post",
        url: url + "uploadfile",
        data: this.formdata,
        config: { headers: { "Content-Type": "multipart/form-data" } }
      }).then(res => {
        this.reset()

        this.$message("上传成功");

      });
    },

    filedelete() {
      let deleteitems = []//希望得到的如[{_id:"asdfasdf",Filename:"asdf.pdf",path:""}]
      this.deletes.forEach(i => {
        deleteitems.push(this.thedata.doc[i])
      })
      // this.thedata.doc.forEach(o){

      // }
      let info = { collection: this.collection, id: this.rowdata._id, deleteitems: deleteitems }
      this.$axios({
        method: "post",
        url: url + "filedelete",
        data: info,
      }).then(res => {
        this.reset()
        this.$message("已删除");
      })
    }
  }
};
</script>




// WEBPACK FOOTER //
// src/components/utility/commonfields/file/uploadfile.vue